import styled from "styled-components";

export const Titulo = styled.div`
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 4px;
`;

export const Mensagem = styled.p`
  font-size: 14px;
  color: #555;
  margin: 0;
  line-height: 1.4;
  white-space: pre-wrap;
`;
